import React from "react";
import {useParams} from "react-router-dom";

import StringInput from "../../../formElements/StringInput";
import DateInput from "../../../formElements/DateInput";
import SelectInput from "../../../formElements/SelectInput";
import RichTextInput from "../../../formElements/RichTextInput";
import MultiFileInput from "../../../formElements/MultiFileInput";

import RegimeCostList from "../../../tableLists/RegimeCostList";
import InstrumentBTKSection from "./InstrumentBTKSection";

import FormContext from "../../../support/FormContext";

import GenericForm from "../../GenericForm";

import "./_static/BTKForm.css"
import "../../../../buttons/_static/Buttons.css";
import TwoColumnRows from "../../../formElements/TwoColumnRows";

import {useModal} from "../../../../dialogs/ModalContext";
import PopupConfirmationWarning from "../../../../dialogs/PopupConfirmationWarning";
import FloatInput from "../../../formElements/FloatInput";
import {getAppName} from "../../../../Api";
import {parseFloatWithPrecision} from "../../../../../support/math";
import InternalNote from "../../serviceCase/serviceCaseForm/InternalNote";
import FreeTypeSelectInput from "../../../formElements/FreeTypeSelectInput";

function BTKForm(props) {

    const {id} = useParams()
    const baseUrl = '/btk/btks/'
    const [fileData, setFileData] = React.useState([]);
    const [isSectionAdded, setIsSectionAdded] = React.useState(false)
    const [nextBtkData, setNextBtkData] = React.useState(null)
    const {showModal} = useModal();

    function customSubmit(data) {
        const formData = new FormData();
        formData.append('data', data);
        fileData.forEach((file, index) => {
            if (file["newFile"] === true) {
                formData.append(`file_${index}`, file["file"]);
                formData.append(`file_${index}_print`, file["print"]);
            }
        });
        return formData
    }

    function parseFromData(data, commonParseFromData) {
        data.Prilohy = []
        data = commonParseFromData(data)
        fileData.forEach((item, index) => {
            if (item.newFile === false) {
                data.Prilohy.push({Priloha: item.file, Subor: item.file, Tlacit: item.print, id: item.id})
            }
        })
        return data
    }

    function parseData(data, commonParseData) {
        let newData = commonParseData(data)
        if (newData.id === null) {
            const appName = getAppName()
            const user = localStorage.getItem(`${appName}_user`)
            const loggedTechnik = newData.Technik_options.find((item) => item.username === user)
            if (loggedTechnik !== undefined) {
                newData.Technik = loggedTechnik
            }
        }
        newData.Pristroje.forEach((pristroj) => {
            pristroj.Nahradne_Diely.forEach((part) => {
                part.Predajna_Cena_Ks = parseFloatWithPrecision(part.Cena_Ks * part.Koeficient, 2)
            })
        })
        updateNextBtkData(newData)
        return newData
    }

    function updateNextBtkData(data) {
        if (data.Nasledujuca_Kontrola === null) {
            setNextBtkData(null)
        } else {
            setNextBtkData(data)
        }
    }


    function formContent(data, update, updateCustom) {
        function selectInstrument(event, index,) {
            const newData = {...data}
            const newInstrument = data.Zakaznik_pristroje_options[data.Zakaznik].find(
                // (item) => item.SNR === event.target.value.SNR && item["Produkt"].Typ === event.target.value["Produkt"].Typ
                (item) => item.SNR === event.target.value.SNR && item.Produkt.Typ === event.target.value.Produkt.Typ
            )
            if (index !== undefined) {
                newData.Pristroje[index].Pristroj = newInstrument
            } else {
                setIsSectionAdded(true)
                newData.Pristroje.push({
                    Pristroj: newInstrument,
                    Stav_Nedostatky: null,
                    Vysledok_Kontroly: null,
                    Poznamka: null,
                    Vykonane_Prace: null,
                    Zoznam_Prac: [],
                    Nahradne_Diely: []
                })
            }
            updateCustom(newData)
        }

        function deleteInstrument(index,) {
            const newData = {...data}
            newData.Pristroje.splice(index, 1)
            updateCustom(newData)
        }

        function selectBTKResult(event, index) {
            const newData = {...data}
            let selectedResult = null
            if (event.target.value !== "") {
                selectedResult = data.Vysledok_Kontroly_options.find((item) => item.Vysledok === event.target.value).Vysledok
            }
            newData.Pristroje[index].Vysledok_Kontroly = selectedResult
            updateCustom(newData)
        }

        function selectItem(event, itemIndex, newItemTemplate, itemPath, itemName, addedNew) {
            // generic function for selecting item from combobox input and handling data modification
            const newData = {...data}
            let newItem = event.target.value
            if (typeof newItem === 'string') {
                // if no item is selected but user typed something, it will return string. In that case create new item object.
                newItem = newItemTemplate
            }
            const pathsArray = itemPath.split('.')
            let fullPath = newData
            pathsArray.forEach(path => {
                fullPath = fullPath[path]
            })
            if (!addedNew) {
                const cenaKs = fullPath[itemIndex].Cena_Ks ? fullPath[itemIndex].Cena_Ks : null
                const koeficient = fullPath[itemIndex].Koeficient ? fullPath[itemIndex].Koeficient : null
                const skladovaPolozka = fullPath[itemIndex].Skladova_Polozka ? fullPath[itemIndex].Skladova_Polozka : false
                fullPath[itemIndex] = {
                    Cena_Ks: cenaKs,
                    Pocet: fullPath[itemIndex].Pocet ? fullPath[itemIndex].Pocet : 1,
                    [itemName]: newItem
                }
                if (itemName === "Nahradny_Diel") {
                    fullPath[itemIndex].Koeficient = koeficient
                    fullPath[itemIndex].Predajna_Cena_Ks = cenaKs && koeficient? parseFloatWithPrecision(fullPath[itemIndex].Cena_Ks * koeficient, 2) : null
                    fullPath[itemIndex].Skladova_Polozka = skladovaPolozka
                }
            } else {
                const koeficient_marze = data.Zakaznik_options.find((item) => item.Meno === data.Zakaznik).Koeficient_marze
                if (event.target.value === '') {
                    return
                }
                let newObject = {
                    Cena_Ks: newItem.Cena ? newItem.Cena : null,
                    Pocet: 1,
                    [itemName]: newItem,
                };

                if (itemName === "Nahradny_Diel") {
                    newObject.Koeficient = koeficient_marze;
                    newObject.Predajna_Cena_Ks = parseFloatWithPrecision(newObject.Cena_Ks * koeficient_marze, 2)
                    newObject.Skladova_Polozka = false
                }
                fullPath.push(newObject);
            }
            updateCustom(newData)
        }

        function selectWork(event, pristrojIndex, workIndex) {
            let newItemTemplate = null
            const addedNew = workIndex === data.Pristroje[pristrojIndex].Zoznam_Prac.length
            if (!addedNew) {
                newItemTemplate = data.Pristroje[pristrojIndex].Zoznam_Prac[workIndex].Vykonana_Praca
                newItemTemplate[event.target.name] = event.target.value
            } else {
                newItemTemplate = {
                    "id": null,
                    "Popis": '',
                    "Kod_Prace": '',
                    "Cena": null
                }
                newItemTemplate[event.target.name] = event.target.value
            }
            const itemPath = `Pristroje.${pristrojIndex}.Zoznam_Prac`
            const itemName = "Vykonana_Praca"
            selectItem(event, workIndex, newItemTemplate, itemPath, itemName, addedNew)
        }

        function updateWork(updatedItem, pristrojIndex, itemIndex) {
            const newData = {...data}
            newData.Pristroje[pristrojIndex].Zoznam_Prac[itemIndex] = updatedItem
            updateCustom(newData)
        }

        function deleteWork(pristrojIndex, workIndex,) {
            const newData = {...data}
            newData.Pristroje[pristrojIndex].Zoznam_Prac.splice(workIndex, 1)
            updateCustom(newData)
        }

        function selectPart(event, pristrojIndex, partIndex,) {
            let newItemTemplate = null
            const addedNew = partIndex === data.Pristroje[pristrojIndex].Nahradne_Diely.length
            if (!addedNew) {
                newItemTemplate = data.Pristroje[pristrojIndex].Nahradne_Diely[partIndex].Nahradny_Diel
                newItemTemplate[event.target.name] = event.target.value
            } else {
                newItemTemplate = {
                    "id": null,
                    "Nazov": '',
                    "Objednavaci_Kod": '',
                    "Cena": null
                }
                newItemTemplate[event.target.name] = event.target.value
            }
            const itemPath = `Pristroje.${pristrojIndex}.Nahradne_Diely`
            const itemName = "Nahradny_Diel"
            selectItem(event, partIndex, newItemTemplate, itemPath, itemName, addedNew)
        }

        function updatePart(updatedItem, pristrojIndex, itemIndex, updatedElement) {
            if (updatedElement === "Predajna_Cena_Ks") {
                updatedItem.Koeficient = updatedItem.Predajna_Cena_Ks / updatedItem.Cena_Ks
            } else if (updatedElement === "Cena_Ks") {
                updatedItem.Predajna_Cena_Ks = parseFloatWithPrecision(updatedItem.Cena_Ks * updatedItem.Koeficient, 2)
            } else if (updatedElement === "Koeficient") {
                updatedItem.Predajna_Cena_Ks = parseFloatWithPrecision(updatedItem.Cena_Ks * updatedItem.Koeficient, 2)
            }
            const newData = {...data}
            newData.Pristroje[pristrojIndex].Nahradne_Diely[itemIndex] = updatedItem
            updateCustom(newData)
        }

        function deletePart(pristrojIndex, partIndex) {
            const newData = {...data}
            newData.Pristroje[pristrojIndex].Nahradne_Diely.splice(partIndex, 1)
            updateCustom(newData)
        }

        function selectCost(event, pristrojIndex, costIndex,) {
            const addedNew = costIndex === data.Rezijne_Naklady.length
            const newItemTemplate = {
                "id": null,
                "Nazov": event.target.value,
                "Cena": null
            }
            const itemPath = `Rezijne_Naklady`
            const itemName = "Rezijny_Naklad"
            selectItem(event, costIndex, newItemTemplate, itemPath, itemName, addedNew)
        }

        function updateCost(updatedItem, pristrojIndex, itemIndex) {
            const newData = {...data}
            newData.Rezijne_Naklady[itemIndex] = updatedItem
            updateCustom(newData)
        }

        function deleteCost(pristrojIndex, index) {
            // pristojIndex is not used, but it is here to keep the same signature as other delete functions
            // this is a shameful solution, I will keep this comment here as a reminder to the couchpotatedness of it
            const newData = {...data}
            newData.Rezijne_Naklady.splice(index, 1)
            updateCustom(newData)
        }

        function updateAddress(event,) {
            let selectedAddressId = null
            if (event.target.value !== "") {
                const customerAddresses = getCurrentCustomerAddresses()
                const selectedAddress = customerAddresses.find((item) => formatAddress(item) === event.target.value)
                selectedAddressId = selectedAddress.id
            }
            const newData = {...data}
            newData.Umiestnenie = selectedAddressId
            updateCustom(newData)
        }

        function deleteLink(index,) {
            const newData = {...data}
            newData.Prilohy.splice(index, 1)
            updateCustom(newData)
        }

        function get_place(data) {
            const customerAddresses = getCurrentCustomerAddresses()
            if (customerAddresses.length === 0) {
                return ""
            }
            if (data.Umiestnenie === null) {
                return ""
            }
            const selectedAddress = customerAddresses.find((item) => item.id === data.Umiestnenie)
            return formatAddress(selectedAddress)
        }

        function updateCustomer(event,) {
            const newCustomer = event.target.value
            if (data.Pristroje.length > 0) {
                showModal(PopupConfirmationWarning,
                    "Pre existujúceho zákazníka už boli zvolené prístroje. Pri zmene zákazníka sa tieto záznamy vymažú. Chcete pokračovať?", (confirm) => {
                        promtCustomerChange(newCustomer, confirm)
                    })
            } else {
                handleCustomerChange(newCustomer)
            }
        }

        function promtCustomerChange(newCustomer, confirm) {
            if (confirm) {
                handleCustomerChange(newCustomer)
            }
        }

        function handleCustomerChange(newCustomer) {
            const newData = {...data}
            newData.Pristroje = []
            newData.Zakaznik = newCustomer
            const customerLocations = getCustomerAddresses(newCustomer)
            if (customerLocations.length === 1) {
                newData.Umiestnenie = customerLocations[0].id
            } else {
                newData.Umiestnenie = null
            }
            updateCustom(newData)
        }

        function getPlaceOptions(data) {
            // filters addresses based on selected customer
            if (data.Zakaznik !== null && data.Zakaznik !== "") {
                const customerAddresses = getCurrentCustomerAddresses(data)
                if (customerAddresses.length === 0) {
                    return []
                }
                let newOptions = customerAddresses.map((item) => formatAddress(item))
                newOptions.unshift("")
                return newOptions
            }
            return []
        }

        function formatAddress(address) {
            return `${address.Nazov}; ${address.Mesto}; ${address.Ulica}; ${address.PSC}`
        }

        function getCurrentCustomerAddresses() {
            if (data.Zakaznik === null || data.Zakaznik === "") {
                return []
            }
            return getCustomerAddresses(data.Zakaznik)
        }

        function getCustomerAddresses(customer) {
            if (customer) {
                return data.Firma_Adresa_options.find((item) => item.company === customer).addresses
            }
            return []
        }

        function getCustomerOptions() {
            const options = Object.keys(data.Zakaznik_pristroje_options)
            return options ? ['', ...options] : []
        }

        function selectTechnique(event,) {
            const newVal = event.target.value
            const newData = {...data}
            if (newVal === "") {
                newData.Technik = null
            } else {
                newData.Technik = data.Technik_options.find((item) => item.username === newVal)
            }
            updateCustom(newData)
        }

        function changeNewFilePrint(index, value) {
            let updatedFileData = [...fileData]
            updatedFileData[index].print = value
            setFileData(updatedFileData)
        }

        function updateExecutionDate(event) {
            const newData = {...data}
            newData.Datum_Vykonania = event.target.value
            let nextControlDate = new Date(event.target.value)
            nextControlDate.setFullYear(nextControlDate.getFullYear() + 1)
            newData.Nasledujuca_Kontrola = nextControlDate.toISOString().split('T')[0]
            updateNextBtkData(newData)
            updateCustom(newData)
        }

        function updateNextDate(event) {
            const newData = {...data}
            newData.Nasledujuca_Kontrola = event.target.value
            updateNextBtkData(newData)
            updateCustom(newData)
        }

        return <>
            <FormContext.Provider value={{data: data, isSectionAdded: isSectionAdded}}>
                <label className="form-label">Číslo</label>
                <p value={data.Cislo} disabled={true} style={{"backgroundColor": "#e9ecef"}}
                   className="form-control">{data.Cislo}</p>
                <StringInput name={'Nadpis'} label={'Hlásená porucha'} value={data.Nadpis} onChange={update}/>
                <TwoColumnRows>
                    <SelectInput options={['', ...data.Technik_options.map(option => option.username)]}
                                 name={'Technik'}
                                 label={'Technik'}
                                 value={data.Technik ? data.Technik.username : null}
                                 onChange={selectTechnique}/>
                </TwoColumnRows>
                <TwoColumnRows>
                    <DateInput name={'Datum_Otvorenia'} label={'Dátum Otvorenia'} value={data.Datum_Otvorenia}
                               onChange={update}/>
                    <DateInput name={'Datum_Uzavretia'} label={'Dátum Uzavretia'} value={data.Datum_Uzavretia}
                               onChange={update}/>
                    <DateInput name={'Datum_Vykonania'} label={'Dátum Vykonania'} value={data.Datum_Vykonania}
                               onChange={updateExecutionDate}/>
                    <DateInput name={'Datum_Planovanej_BTK'} label={'Dátum Plánovanej BTK'}
                               value={data.Datum_Planovanej_BTK}
                               onChange={update}/>
                    <DateInput name={'Nasledujuca_Kontrola'} label={'Nasledujúca Kontrola'}
                               value={data.Nasledujuca_Kontrola}
                               onChange={updateNextDate}/>
                </TwoColumnRows>
                <TwoColumnRows>
                    <FreeTypeSelectInput options={getCustomerOptions()} name={'Zakaznik'} label={'Zákazník'}
                                 value={data.Zakaznik} onChange={updateCustomer}/>
                    <SelectInput options={getPlaceOptions(data)} name={'Umiestnenie'} label={'Umiestnenie'}
                                 value={get_place(data)} onChange={updateAddress}/>
                    <SelectInput options={data.Stav_options} name={'Stav'} label={'Stav Servisu'}
                                 value={data.Stav}
                                 onChange={update}/>
                </TwoColumnRows>
                <TwoColumnRows>
                    <StringInput name={'Objednavka'} label={'Objednávka'} value={data.Objednavka}
                                 onChange={update}/>
                    <DateInput name={'Datum_Objednavky'} label={'Dátum Objednávky'}
                               value={data.Datum_Objednavky}
                               onChange={update}/>
                    <FloatInput name={'DPH'}
                                label={'DPH'}
                                value={data.DPH} onChange={update}/>
                </TwoColumnRows>
                <InstrumentBTKSection selectPart={selectPart} deletePart={deletePart}
                                      updatePart={updatePart}
                                      selectWork={selectWork} deleteWork={deleteWork}
                                      updateWork={updateWork}
                                      deleteInstrument={deleteInstrument}
                                      selectInstrument={selectInstrument}
                                      selectBTKResult={selectBTKResult}
                                      data={data} update={update}/>
                <RegimeCostList delete={deleteCost} select={selectCost} update={updateCost} data={data}/>
                <RichTextInput name={'Poznamka'} label={'Poznámka'} value={data.Poznamka}
                               onChange={update}/>
                <InternalNote name={'Interna_Poznamka'} label={'Interná Poznámka'}
                              value={data.Interna_Poznamka}
                              onChange={update}/>
                <MultiFileInput fileData={fileData} setFileData={setFileData} data={data}
                                onChange={changeNewFilePrint}/>
            </FormContext.Provider>
        </>
    }


    return (
        <GenericForm label="BTK"
                     labelNew="Pridať BTK"
                     baseUrl={baseUrl}
                     id={id}
                     formContent={formContent}
                     customSubmit={customSubmit}
                     contentType={'multipart/form-data'}
                     parseData={parseData}
                     parseFromData={parseFromData}
                     reloadDataAfterSave={true}
                     nextBtkData={nextBtkData}
                     // qrGeneration={true}
                     priceOffer={"CBTK"}
                     reportGeneration={"BTK"}
                     reportType="btk"
                     progressWhenSaving={true}
        />
    )
}

export default BTKForm